import React, { useState, useEffect } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import useApi from 'hooks/useApi';

const MultiSelectGroup = (
    {
        CurrentValue = null, DataList = [], onChange, onFilter = null, endpoint = null,
        fields = [], multiSelect = true, name = "", disabled = false
    }) => {
    const api = useApi();
    const [GroupList, setGroupList] = useState([]);
    const [SelectedGroups, setSelectedGroups] = useState([]);
    const [SelectedItem, setSelectedItem] = useState(CurrentValue);

    const _label = fields.label ? fields.label : "label";
    const _value = fields.value ? fields.value : "value";

    // Load List API
    useEffect(() => {
        // Retorna com os Grupos
        if (DataList && DataList.length > 0) {
            setGroupList((prev) => {
                if (JSON.stringify(prev) !== JSON.stringify(DataList)) {
                    return [...DataList]; // Update only if different
                }
                return prev;
            });
        }
        else {
            const fetchDataGrupsList = async () => {
                var _endpoint = endpoint ? endpoint : 'components_data/grupoid_option_list_2';
                const response = await api.get(_endpoint);
                setGroupList((prev) => {
                    if (JSON.stringify(prev) !== JSON.stringify(response.data)) {
                        return response.data; // Update only if different
                    }
                    return prev;
                });
            };
            fetchDataGrupsList();
        }
        if (CurrentValue && CurrentValue.length > 0) {
            setSelectedGroups((prev) => {
                if (JSON.stringify(prev) !== JSON.stringify(CurrentValue)) {
                    return [...CurrentValue]; // Update only if different
                }
                return prev;
            });
            setSelectedItem((prev) => {
                if (JSON.stringify(prev) !== JSON.stringify(CurrentValue)) {
                    return [...CurrentValue]; // Update only if different
                }
                return prev;
            });
        }
    }
        , [DataList, CurrentValue, api, endpoint]); // Add dependencies to ensure updates

    const onHandleChange = (e) => {
        if (multiSelect) {
            setSelectedGroups(e.value);
            
            // Se precisar verificar o valor, use um useEffect
            if (onChange) {
                onChange(e);
            }
        }
        else {
            setSelectedItem(e.value);
        }
        if (onChange) {
            onChange(e);
        }
    };

    const onHandleFilter = (e) => {
        const searchText = e.filter || ""; // Texto digitado no campo de pesquisa
        const foundItems = GroupList.filter(item =>
            item[_label].toLowerCase().includes(searchText.toLowerCase())
        );
        if (onFilter) { // Se existir a função onFilter, chama ela
            onFilter(foundItems, searchText);
        }
    };

    return (
        <>
            {multiSelect ? (
                <MultiSelect
                    name={name}
                    options={GroupList}
                    value={SelectedGroups}  // Descomente esta linha
                    onChange={onHandleChange}
                    optionLabel={_label}
                    optionValue={_value}
                    filter
                    placeholder="Selecione os Grupos"
                    //maxSelectedLabels={3}
                    display="chip"
                    style={{ width: "100%" }}
                    disabled={disabled}
                />
            ) : (
                <Dropdown
                    name={name}
                    filter
                    value={SelectedItem}
                    options={GroupList}
                    optionLabel={_label}
                    optionValue={_value}
                    onChange={onHandleChange}
                    onFilter={onHandleFilter}
                    style={{ width: "100%" }}
                    disabled={disabled}
                />
            )}
        </>
    );
};

export default MultiSelectGroup;
